function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n    transform: translateY(-50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    animation: ",
        " 0.3s ease-in-out 0s 1 normal forwards;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    animation: ",
        " 0.3s ease-in-out 0s 1 normal forwards;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { css, keyframes } from "styled-components";
var fadeIn = keyframes(_templateObject());
var slideIn = keyframes(_templateObject1());
/**
 * Common keyframes and animation timings.
 * TODO(b/273780062): move more common animations/keyframes here.
 *
 * Usage example:
 *
 * @example
 * const CondensedHeading = styled.div<{ $isScrolled: boolean }>`
 *  visibility: ${p => (p.$isScrolled ? "visible" : "hidden")};
 *  ${p => p.$isScrolled && p.theme.km.animations.withSlideIn}
 * `;
 */ export var animations = {
    fadeIn: fadeIn,
    slideIn: slideIn,
    withSlideIn: css(_templateObject2(), slideIn),
    withFadeIn: css(_templateObject3(), fadeIn)
};
